const bindClick = <T>(setVal: (val: T)=>void, val: T=null)=>{
	return ()=>{
		setVal(val);
	}
}

const bindFormChange = <T>(val: T, setVal: (val: any, ...args: any)=>void, setDirty?: (val: boolean)=>void)=>{
	return (name: keyof T, semantic: boolean=false, target: boolean=false)=>{
		return (e: { target: { value: string } } | any, data?: { value?: any, checked: boolean } | any)=>{
			if(semantic){
				setVal({ ...val, [name]: typeof data.checked!=='undefined' ? data.checked : data.value });
			}else if(target){
				setVal({ ...val, [name]: e.target.value })
			}else{
				setVal({ ...val, [name]: e });
			}
			if(setDirty) setDirty(true);
		}
	}
}

function randomRange(min: number, max: number){
	return Math.floor(Math.random() * (max-min+1)+min);
}

function addCommas(num: number, fixed: boolean=true, hideZero: boolean=false){
	if (!num && num !== 0) return null;
	if(typeof num==='string'){
		num = parseFloat(num as string);
	}
	var c = num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	var dec = c.substring(c.length-2, c.length);
	return fixed ? (hideZero && dec == '00' ? c.slice(0, -3) : c) : c.slice(0, -3);
}

function toCents(amount: number){
	return Math.round(100 * amount);
}

function isJWT(token: string){
	return (/(^[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*\.[A-Za-z0-9-_]*$)/gi).test(token);
}

function filterSearch<T>(search: string, key: keyof T){
	var normal_search = search.normalize('NFD').toLowerCase();
	return (a: T)=>{
		if(!a[key]) return false;
		return (a[key].toString()).toLowerCase().normalize('NFD').indexOf(normal_search)!==-1;
	}
}

function isCardValid(number: string){
	number = number.replace(/\D/g,'');

	// visa
	var re = new RegExp("^4");
	if (number.match(re) != null) return true;
	
	// Mastercard 
	// Updated for Mastercard 2017 BINs expansion
	if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) return true;
	
	// AMEX
	re = new RegExp("^3[47]");
	if (number.match(re) != null) return true;
	
	// Discover
	re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
	if (number.match(re) != null) return true;
	
	// Visa Electron
	re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
	if (number.match(re) != null) return true;
	
	return false;
}

const REGIMENES_FISCALES = [
	{ text: "Regimen General de Ley Personas Morales", value: 601, description: "(601)" },
	{ text: "Régimen Simplificado de Ley Personas Morales", value: 602, description: "(602)" },
	{ text: "Personas Morales Con Fines No Lucrativos", value: 603, description: "(603)" },
	{ text: "Régimen de Pequeños Contribuyentes", value: 604, description: "(604)" },
	{ text: "Régimen de Sueldos Y Salarios e Ingresos Asimilados a Salarios", value: 605, description: "(605)" },
	{ text: "Régimen de Arrendamiento", value: 606, description: "(606)" },
	{ text: "Régimen de Enajenación o Adquisición de Bienes", value: 607, description: "(607)" },
	{ text: "Régimen de los Demás Ingresos", value: 608, description: "(608)" },
	{ text: "Régimen de Consolidación", value: 609, description: "(609)" },
	{ text: "Régimen Residentes en el Extranjero Sin Establecimiento Permanente en México", value: 610, description: "(610)" },
	{ text: "Régimen de Ingresos por Dividendos (Socios y Accionistas)", value: 611, description: "(611)" },
	{ text: "Régimen de las Personas Físicas con Actividades Empresariales y Profesionales", value: 612, description: "(612)" },
	{ text: "Régimen Intermedio de las Personas Físicas con Actividades Empresariales", value: 613, description: "(613)" },
	{ text: "Régimen de los Ingresos Por Intereses", value: 614, description: "(614)" },
	{ text: "Régimen de los Ingresos Por Obtención de Premios", value: 615, description: "(615)" },
	{ text: "Sin Obligaciones Fiscales", value: 616, description: "(616)" },
	{ text: "Pemex", value: 617, description: "(617)" },
	{ text: "Régimen Simplificado de Ley Personas Físicas", value: 618, description: "(618)" },
	{ text: "Ingresos Por la Obtención de Préstamos", value: 619, description: "(619)" },
	{ text: "Sociedades Cooperativas de Producción Que Optan por Diferir Sus Ingresos", value: 620, description: "(620)" },
	{ text: "Régimen de Incorporación Fiscal", value: 621, description: "(621)" },
	{ text: "Régimen de Actividades Agrícolas, Ganaderas, Silvícolas Y Pesqueras PM", value: 622, description: "(622)" },
	{ text: "Régimen de Opcional Para Grupos de Sociedades", value: 623, description: "(623)" },
	{ text: "Régimen de los Coordinados", value: 624, description: "(624)" },
	{ text: "Régimen de las Actividades Empresariales Con Ingresos a Través de Plataformas Tecnológicas", value: 625, description: "(625)" },
	{ text: "Régimen Simplificado de Confianza", value: 626, description: "(626)" },
];

const CFDI_LIST = [
	{ code: "G01", text: "Adquisición de mercancías", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625,626] },
	{ code: "G02", text: "Devoluciones, descuentos o bonificaciones", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625,626] },
	{ code: "G03", text: "Gastos en general", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I01", text: "Construcciones", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I02", text: "Mobiliario y equipo de oficina por inversiones", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I03", text: "Equipo de transporte", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I04", text: "Equipo de computo y accesorios", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I05", text: "Dados, troqueles, moldes, matrices y herramental", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I06", text: "Comunicaciones telefónicas", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I07", text: "Comunicaciones satelitales", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "I08", text: "Otra maquinaria y equipo", regimen: [601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
	{ code: "D01", text: "Honorarios médicos, dentales y gastos hospitalarios", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D02", text: "Gastos médicos por incapacidad o discapacidad", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D03", text: "Gastos funerales", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D04", text: "Donativos", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D05", text: "Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D06", text: "Aportaciones voluntarias al SAR", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D07", text: "Primas por seguros de gastos médicos", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D08", text: "Gastos de transportación escolar obligatoria", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D09", text: "Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "D10", text: "Pagos por servicios educativos (colegiaturas)", regimen: [605, 606, 608, 611, 612, 614, 607, 615, 625] },
	{ code: "S01", text: "Sin efectos fiscales", regimen: [601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626] },
	{ code: "CP01", text: "Pagos", regimen: [601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626] },
	{ code: "CN01", text: "Nómina", regimen: [605] },
]

var getCFDIList = (regimen: number)=>{
	var list : typeof CFDI_LIST = null;
	if(!regimen) list = [...CFDI_LIST];
	else{
		list = CFDI_LIST.filter(a=>a.regimen.indexOf(regimen)!=-1);
	}

	return list.map(a=>({
		text: a.text,
		value: a.code,
		description: `(${a.code})`,
	}));
}
    

export {
	REGIMENES_FISCALES,
	addCommas,
	bindClick,
	bindFormChange,
	filterSearch,
	getCFDIList,
	isCardValid,
	isJWT,
	randomRange,
	toCents,
}